package org.braunequip.web.components.models

import kotlinx.serialization.Serializable

@Serializable
data class AssetDTO(
    var id: Int? = null,
    var type: Short? = null,
    var assetname: String = "",
    var equipmentname: String = "",
    var description: String = "",
    var status: Short? = null,
    var year: String = "",
    var vin: String? = null,
    var miles: Int = 0,
    var totalMaintItems: Int? = null, //New field in my DTO
    var createdAt: String? = null,
    val eroadId: String? = null,
    var eroadLastUpdate: String? = null,
)